/*
 * @Description:
 * @Author: 琢磨先生
 * @Date: 2024-07-11 17:39:52
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2024-10-14 15:29:08
 */
import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import Layout from '@/layout'
import RouteLayout from '@/layout/layout2.vue'
import menus from '@/config/menus.js'
import config from '@/config/config.js'

const routes = [
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login')
	},
	{
		path: '/profile',
		name: 'profile',
		component: () => import('@/views/profile')
	},
	{
		path: '/paytool',
		name: 'paytool',
		component: () => import('@/views/h5/paytool')
	}
]

menus.forEach((item) => {
	item.component = Layout
	routes.push(item)
})

const router = createRouter({
	history: createWebHistory(),
	routes: routes
})

/**
 * 前置守卫
 */
router.beforeEach((to, from, next) => {
	NProgress.start()
	const isLoggedIn = localStorage.getItem(config.TOKEN)

	// 情况1：未登录且访问非登录页 → 跳登录
	if (!isLoggedIn && to.path !== '/login') {
		next('/login')
	}
	// 情况2：已登录且访问登录页 → 跳首页
	else if (isLoggedIn && to.path === '/login') {
		next('/')
	}
	// 情况3：其他情况（包括已登录访问非登录页）→ 直接放行
	else {
		next()
	}
})

/**
 * 后置守卫
 */
router.afterEach((to, from, next) => {
	NProgress.done()
})

export default router
